import React, { useState } from 'react';
import { SubMenu } from 'rc-menu';
import { unifiedStopPropagation } from '../../../../util/unifiedStopPropagation';
import { getItemsIntoComponentsTransformer } from '../../util/getItemsIntoComponentsTransformer';
import { SearchBar } from '../SearchBar';
import { DropdownItem, DropdownComponentProps } from '../types';
import styles from './SubDropdownWithSearch.module.scss';
import { escapeRegexString } from '../../../../util/escapeRegexString';

export const SubDropdownWithSearch: React.FC<DropdownComponentProps> = ({
  item,
  itemLevel,
  ...props
}) => {
  const [searchValue, setSearchValue] = useState('');

  const itemSearchPredicate = (child: DropdownItem) => {
    const name = child.searchTerm();

    if (child.isDivider() || !name) return true;

    return searchValue.length > 1
      ? new RegExp(escapeRegexString(searchValue), 'i').test(name)
      : true;
  };

  const transformItemsIntoComponents = getItemsIntoComponentsTransformer(
    itemLevel,
    itemSearchPredicate,
  );

  return (
    <SubMenu
      {...props}
      title={item.title()}
      popupClassName={styles.searchBar}
      onTitleClick={unifiedStopPropagation}
    >
      <SearchBar
        key={`${itemLevel}.search-bar`}
        value={searchValue}
        onChange={setSearchValue}
      />
      {transformItemsIntoComponents(item.children())}
    </SubMenu>
  );
};

SubDropdownWithSearch.displayName = 'SubDropdownWithSearch';
